import { render, staticRenderFns } from "./RateSort.vue?vue&type=template&id=2a2d9b86&"
import script from "./RateSort.vue?vue&type=script&lang=js&"
export * from "./RateSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports